import BoardItemDetail from './BoardItemDetail';

export default BoardItemDetail;
